import { arrayOf, Schema } from 'normalizr';

import { getProxiedAudioURL } from '../lib/utils/url';

/**
 * If configured, override audioURL to go through a proxy
 * allows us to modify the returned data for testing (headers, encrypt audio, transmux, etc)
 */
const playlistTrackOptions = (() => {
  const options = {
    idAttribute: 'trackToken',
  };

  if (AUDIO_URL_DEV_PROXY) {
    options.assignEntity = (output, key, value) => {
      if (key === 'audioURL') {
        output[key] = getProxiedAudioURL(value);
        if (AUDIO_URL_DEV_PROXY_DECRYPTION_KEY) {
          output.key = AUDIO_URL_DEV_PROXY_DECRYPTION_KEY;
        }
        return;
      }
      output[key] = value;
    };
  }
  return options;
})();

const listener = new Schema('listeners', { idAttribute: 'listenerId' });
const seed = new Schema('seeds', { idAttribute: 'musicId' });
const feedback = new Schema('feedback', { idAttribute: 'feedbackId' });
const artist = new Schema('artists', { idAttribute: 'musicId' });
const composer = new Schema('composers', { idAttribute: 'musicId' });
const event = new Schema('events', { idAttribute: 'id' });
const album = new Schema('albums', { idAttribute: 'musicId' });
const playlist = new Schema('playlists', { idAttribute: 'pandoraId' });
const playlistTrack = new Schema('playlistTracks', playlistTrackOptions); // track data from "playlist/getFragment" API call
const track = new Schema('tracks', { idAttribute: 'musicId' }); // track data from "music/track" API call
const lyric = new Schema('lyrics', { idAttribute: 'lyricId' });
const station = new Schema('stations', { idAttribute: 'stationId' });
const catalogStation = new Schema('catalogStation', {
  idAttribute: 'pandoraId',
});
const genre = new Schema('genres', { idAttribute: 'musicId' });
const genreCategory = new Schema('categories', { idAttribute: 'token' });
const browseCategory = new Schema('categories', { idAttribute: 'categoryId' });
const browseSource = new Schema('browseSource', { idAttribute: 'pandoraId' });
const noEntity = new Schema('noEntity'); // noEntity is not used to normalize data

browseCategory.define({
  stations: arrayOf(catalogStation),
});

const genresList = {
  genres: arrayOf(genre),
};

const browseMusicCatalog = {
  catalog: {
    stations: arrayOf(catalogStation),
    categories: arrayOf(browseCategory),
    sources: arrayOf(browseSource),
  },
};

const genreCategoriesList = {
  categories: arrayOf(genreCategory),
};

const searchRecommendations = {
  artists: arrayOf(artist),
  genreStations: arrayOf(genre),
};

const seedSuggestions = arrayOf(artist);

const seedList = {
  seeds: arrayOf(seed),
};

const stationList = {
  stations: arrayOf(station),
};

const feedbackResponse = {
  feedback: arrayOf(feedback),
};

const fragment = {
  tracks: arrayOf(playlistTrack),
};

const replayTrack = {
  replayTrack: playlistTrack,
};

artist.define({
  similar: arrayOf(artist),
  events: arrayOf(event),
  discography: arrayOf(album),
});

track.define({
  similar: arrayOf(track),
});

station.define({
  initialSeed: seed,
  seeds: arrayOf(seed),
});

genre.define({
  sampleTracks: arrayOf(track),
  sampleArtists: arrayOf(artist),
});

export const Schemas = {
  LYRIC: lyric,
  LISTENER: listener,
  STATION: station,
  ALBUM: album,
  PLAYLIST: playlist,
  PLAYLIST_TRACK: playlistTrack,
  TRACK: track,
  FEEDBACK: feedbackResponse,
  ARTIST: artist,
  COMPOSER: composer,
  EVENTS: event,
  FRAGMENT: fragment,
  STATION_LIST: stationList,
  GENRES_LIST: genresList,
  GENRE_CATEGORIES_LIST: genreCategoriesList,
  NO_ENTITY: noEntity,
  SEARCH_RECOMMENDATIONS: searchRecommendations,
  REPLAY_TRACK: replayTrack,
  SEED_SUGGESTIONS: seedSuggestions,
  SEED_LIST: seedList,
  BROWSE_MUSIC_CATALOG: browseMusicCatalog,
};
